module.exports = __webpack_public_path__ + "img/DAVID_CANNON_31-rs.5c52c0a0.jpg";